import styled from 'styled-components';

export default styled.div`
  grid-area: title;
  padding: 0 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
